// extracted by mini-css-extract-plugin
export default {"yesno":"yesno--6dce689e"};